import { useTranslation } from '@thoughtspot/i18n';
import { Input } from '@thoughtspot/radiant-react/widgets/input';
import { Vertical } from '@thoughtspot/radiant-react/widgets/layout';
import { Modal, ModalSize } from '@thoughtspot/radiant-react/widgets/modal';
import { Colors, Typography, } from '@thoughtspot/radiant-react/widgets/typography';
import React, { useEffect, useState } from 'react';
import { validateVariableName } from '../utils';
import { TranslationsKeys } from '../variable-interface';
import styles from './rename-modal.module.scss';
export const RenameModal = ({ currentName, isModalOpen, onRenameConfirm, onRenameModalClose, externalNameError, clearExternalNameError, }) => {
    const { t } = useTranslation();
    const [newName, setNewName] = useState('');
    const [nameError, setNameError] = useState(null);
    useEffect(() => {
        if (isModalOpen && currentName) {
            setNewName(currentName);
            setNameError(null);
        }
    }, [isModalOpen, currentName]);
    useEffect(() => {
        if (externalNameError) {
            setNameError(externalNameError);
        }
    }, [externalNameError]);
    const handleNameChange = (value) => {
        setNewName(value);
        if (nameError) {
            setNameError(null);
        }
        if (externalNameError && clearExternalNameError) {
            clearExternalNameError();
        }
    };
    const handleSave = () => {
        const error = validateVariableName(newName);
        if (error) {
            setNameError(error);
            return;
        }
        if (newName.trim() === currentName) {
            onRenameModalClose();
            return;
        }
        onRenameConfirm(newName.trim());
    };
    const handleCancel = () => {
        setNewName(currentName || '');
        setNameError(null);
        onRenameModalClose();
    };
    return (React.createElement(Modal, { isOpen: isModalOpen, size: ModalSize.XSMALL, title: t(TranslationsKeys.MODAL_RENAME_TITLE), confirmButton: {
            text: t(TranslationsKeys.SAVE),
            onConfirm: handleSave,
        }, dismissButton: {
            text: t(TranslationsKeys.CANCEL),
        }, onDismiss: handleCancel },
        React.createElement(Vertical, { className: styles.modalContent },
            React.createElement(Typography, { variant: "content-label-subhead", color: Colors.base, className: styles.modalMessage }, t(TranslationsKeys.MODAL_RENAME_MESSAGE)),
            React.createElement(Vertical, { className: styles.formField },
                React.createElement(Typography, { variant: "content-label-subhead", className: styles.fieldLabel }, t(TranslationsKeys.FIELD_NAME)),
                nameError && (React.createElement(Vertical, { className: styles.inlineError },
                    React.createElement(Typography, { variant: "p-small", className: styles.errorText }, nameError))),
                React.createElement(Input.Text, { value: newName, onChange: e => handleNameChange(e.target.value), placeholder: "e.g., publish_demo_schema_var", hasError: !!nameError, "data-testid": "rename-variable-input" })))));
};
//# sourceMappingURL=rename-modal.js.map